export default function({ state, commit, dispatch, rootState }, { provider, patient, fileObj}) {
    const sendFileObj = {
        ...fileObj,
        uploaded_provider: state.id ? state.id : provider,
        uploaded_by: rootState.auth.id
    }
    return dispatch('post', {
        url: '/provider/' + (state.id ? state.id : provider) + '/patient/' + patient + '/file',
        data: sendFileObj
    }, {
        root: true
    })
    .then((file) => {
      commit('updatePatient', {
        id: patient,
        file: [file]
      })
    })
    .catch((error) => {
		console.log(error)
		throw error
    })
}
